export default function isFundraiserActive(fundraiser) {
  const isPending = !fundraiser?.joinedAt ?? false;
  const isDeactivated = fundraiser?.deactivatedAt ?? false;

  if (isPending) return false;
  if (isDeactivated) return false;
  return true;
}
